import { Link } from "react-router-dom";
import { Phone, MapPin, Mail, Shield, Facebook, Instagram } from "lucide-react";
import { BRAND, CALL_SALES, CALL_SERVICE } from "../lib/constants";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-white rounded-xl p-2">
                <img src={BRAND.logoMark} alt="Hayat" className="h-10 w-10 object-contain" />
              </div>
              <div>
                <div className="font-display text-white font-semibold text-base leading-tight">Hayat Computers</div>
                <div className="text-xs text-slate-400">& Security Solutions</div>
              </div>
            </div>
            <p className="text-sm leading-relaxed text-slate-400">
              Professional CCTV, networking, surveillance & AMC services in Nagpur — trusted by 10,000+ clients for over 15 years.
            </p>
            <div className="mt-4 inline-flex items-center gap-2 text-xs text-[#8BD1E8] font-medium">
              <Shield className="w-3.5 h-3.5" />
              {BRAND.tagline}
            </div>
            <div className="mt-5 flex items-center gap-2">
              <a
                href={BRAND.facebook}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-facebook"
                aria-label="Facebook"
                className="w-9 h-9 rounded-full bg-slate-800 hover:bg-[#1877F2] text-white flex items-center justify-center transition-colors"
              >
                <Facebook className="w-4 h-4" />
              </a>
              <a
                href={BRAND.instagram}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-instagram"
                aria-label="Instagram"
                className="w-9 h-9 rounded-full bg-slate-800 hover:bg-[#E4405F] text-white flex items-center justify-center transition-colors"
              >
                <Instagram className="w-4 h-4" />
              </a>
              <a
                href={BRAND.googleBusiness}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-google"
                aria-label="Google Business"
                className="h-9 px-3 rounded-full bg-slate-800 hover:bg-[#1C6B8A] text-white flex items-center gap-1.5 text-xs font-semibold transition-colors"
              >
                <svg className="w-3.5 h-3.5" viewBox="0 0 24 24"><path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/></svg>
                4.9 ★
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-display text-white font-semibold mb-4">Services</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/services" className="hover:text-white transition-colors">CCTV Installation</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors">Networking Solutions</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors">Surveillance Systems</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors">AMC & Maintenance</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-white font-semibold mb-4">Company</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/projects" className="hover:text-white transition-colors">Projects</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
              <li><a href={BRAND.googleBusiness} target="_blank" rel="noreferrer" className="hover:text-white transition-colors">Google Business</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-white font-semibold mb-4">Reach Us</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-[#8BD1E8] shrink-0" />
                <span className="text-slate-400">{BRAND.address}</span>
              </li>
              <li className="flex gap-3 items-center">
                <Phone className="w-4 h-4 text-[#8BD1E8] shrink-0" />
                <div className="flex flex-col">
                  <a href={CALL_SALES} className="hover:text-white">Sales · {BRAND.salesDisplay}</a>
                  <a href={CALL_SERVICE} className="hover:text-white">Service · {BRAND.serviceDisplay}</a>
                </div>
              </li>
              <li className="flex gap-3 items-center">
                <Mail className="w-4 h-4 text-[#8BD1E8] shrink-0" />
                <a href={`mailto:${BRAND.email}`} className="hover:text-white">{BRAND.email}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-slate-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Hayat Computers and Security Solutions. All rights reserved.</div>
          <div>Owned by Murtaza Hasan · Nagpur, Maharashtra</div>
        </div>
      </div>
    </footer>
  );
}
